export enum MainPage {
  Swap = 'swap',
  Terms = 'terms',
  Index = 'index',
  Referral = 'ref',
  Points = 'points',
  Guilds = 'guilds',
  Vaults = 'vaults',
  Markets = 'markets',
  Portfolio = 'portfolio',
  LpRewards = 'lp-rewards',
  HelixVault = 'helix-vault',
  Maintenance = 'maintenance',
  TradingBots = 'trading-bots',
  FeeDiscounts = 'fee-discounts',
  TradeAndEarn = 'trade-and-earn',
  Institutional = 'institutional',
  PrivacyPolicy = 'privacy-policy',
  PointsS1Ended = 'points-s1-ended',
  TradingBotsLiquidityBots = 'trading-bots-liquidity-bots',
  TradingBotsLiquidityBotsSpot = 'trading-bots-liquidity-bots-spot',
  TradingBotsLiquidityBotsSpotHistory = 'trading-bots-liquidity-bots-spot-history',
  TeslaCompetitionTerms = 'tesla-competition-terms',
  LikeAGCompetitionTerms = 'like-a-g-competition-terms',
  OwnYourAssetCompetitionTerms = 'own-your-assets-competition-terms',
  VolumeVictoryCompetitionTerms = 'volume-victory-competition-terms',
  CompetitionPrivacyPolicyTesla = 'competition-privacy-policy-tesla',
  CompetitionPrivacyPolicyGwagon = 'competition-privacy-policy-gwagon',
  CompetitionPrivacyPolicyOwnYourAsset = 'competition-privacy-policy-own-your-assets'
}

export enum CampaignSubPage {
  GuildDetails = 'guild-guild'
}

export enum TradingBotsSubPage {
  LiquiditySpotMarket = 'trading-bots-liquidity-bots-spot'
}

export enum TradePage {
  Spot = 'spot',
  Futures = 'futures'
}

export enum TradeSubPage {
  Stocks = 'stocks',
  Spot = 'spot-slug',
  Market = 'market-market',
  Futures = 'futures-slug',
  Derivatives = 'derivatives-derivative'
}

export enum TradeSubPagePath {
  Stocks = '/futures/stocks'
}

export enum LiquidityRewardsPage {
  Home = 'lp-rewards',
  Dashboard = 'lp-rewards-dashboard',
  CampaignDetails = 'lp-rewards-campaign'
}

export enum PortfolioSubPage {
  Orders = 'portfolio-orders',
  Settings = 'portfolio-settings',
  Balances = 'portfolio-balances',
  Positions = 'portfolio-positions',
  OrdersSpot = 'portfolio-orders-spot',
  Subaccounts = 'portfolio-subaccounts',
  SettingsAuthz = 'portfolio-settings-authz',
  OrdersFutures = 'portfolio-orders-futures',
  FundingHistory = 'portfolio-funding-history',
  OrdersSpotGrid = 'portfolio-orders-spot-grid',
  OrderHistorySwap = 'portfolio-order-history-swap',
  OrderHistorySpot = 'portfolio-order-history-spot',
  TradeHistorySpot = 'portfolio-trade-history-spot',
  OrdersFuturesGrid = 'portfolio-orders-futures-grid',
  SubaccountsHistory = 'portfolio-subaccounts-history',
  OrderHistoryFutures = 'portfolio-order-history-futures',
  TradeHistoryFutures = 'portfolio-trade-history-futures',
  SettingsAuthzGranter = 'portfolio-settings-authz-granter'
}

export enum LeaderboardSubPage {
  Pnl = 'leaderboard',
  Competition = 'leaderboard-competition',
  PastCompetitions = 'leaderboard-past-competitions'
}
